/**
 * Toggle the modal state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const toggleModal = ({ commit }) => commit('TOGGLE_MODAL')

/**
 * Set the component type
 *
 * @param  {Function} options.commit
 * @param  {String} type
 * @return {Promise}
 */
const setComponentType = ({ commit }, type) => commit('SET_COMPONENT_TYPE', type)

/**
 * Reset the module state
 *
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Set the context for the component/page positions
 *
 * @param  {Function} options.commit
 * @param  {Object} meta
 * @return {Promise}
 */
const setContext = ({ commit }, meta) => commit('SET_CONTEXT', meta)

export default {
    resetState,
    setContext,
    toggleModal,
    setComponentType
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-component/actions.js